import React from 'react';
import Modal from '@omilia/modal';

import WarningModalContent from '../../components/WarningModalContent';

type Props = {
  errorText: string;
  title: string;
  onCancel: () => void;
};

const ErrorModal = ({ errorText, title, onCancel }: Props) => (
  <Modal
    open
    glyph="notification-warning"
    hasBackdrop={false}
    title={title}
    variant="danger"
  >
    <WarningModalContent
      primaryButton={{
        text: 'Close',
        onClick: onCancel,
      }}
      warningText={errorText}
    />
  </Modal>
);

export default ErrorModal;
